export const MAX_SLIDER_DOTS = 3;

export function getSliderDotCount(itemCount) {
  const n = Number(itemCount) || 0;
  if (n <= 1) return 0;
  return Math.min(MAX_SLIDER_DOTS, n);
}

export function getLoopingDotIndex(slideIndex, dotCount) {
  if (!dotCount) return 0;
  const index = Number(slideIndex) || 0;
  return ((index % dotCount) + dotCount) % dotCount;
}

export function resolveLoopingDotTarget(clickedDot, currentSlide, itemCount, dotCount) {
  if (dotCount <= 0 || itemCount <= 0) return 0;

  const safeClicked = getLoopingDotIndex(clickedDot, dotCount);
  let best = safeClicked;
  let bestDist = Infinity;

  for (let slide = safeClicked; slide < itemCount; slide += dotCount) {
    const dist = Math.abs(slide - currentSlide);
    if (dist < bestDist || (dist === bestDist && slide >= currentSlide)) {
      bestDist = dist;
      best = slide;
    }
  }

  return best;
}
